export default __webpack_public_path__ + "static/media/camera_swarm.9ce6e30c.svg";